import React from 'react'
import './faqs.css'
import {AiOutlinePlus} from 'react-icons/ai'
import {AiOutlineMinus} from 'react-icons/ai'
import { useState } from 'react'
import Footer from '../footer/Footer'

const Faqs = () => {
   
    const [faqstate, setfaqstate] = useState(false)

    function openfaq(){
        setfaqstate(faqstate => !faqstate)
    }

    let toggleClassCheck = faqstate ? ' active' : '';

    const [faqstate1, setfaqstate1] = useState(false)

    function openfaq1(){
        setfaqstate1(faqstate1 => !faqstate1)
    }

    let toggleClassCheck1 = faqstate1 ? ' active' : '';

    const [faqstate2, setfaqstate2] = useState(false)

    function openfaq2(){
        setfaqstate2(faqstate2 => !faqstate2)
    }

    let toggleClassCheck2 = faqstate2 ? ' active' : '';

    const [faqstate3, setfaqstate3] = useState(false)

    function openfaq3(){
        setfaqstate3(faqstate3 => !faqstate3)
    }

    let toggleClassCheck3 = faqstate3 ? ' active' : '';

    const [faqstate4, setfaqstate4] = useState(false)

    function openfaq4(){
        setfaqstate4(faqstate4 => !faqstate4)
    }

    let toggleClassCheck4 = faqstate4 ? ' active' : '';

    const [faqstate5, setfaqstate5] = useState(false)

    function openfaq5(){
        setfaqstate5(faqstate5 => !faqstate5)
    }

    let toggleClassCheck5 = faqstate5 ? ' active' : '';

    const [faqstate6, setfaqstate6] = useState(false)

    function openfaq6(){
        setfaqstate6(faqstate6 => !faqstate6)
    }

    let toggleClassCheck6 = faqstate6 ? ' active' : '';

    const [faqstate7, setfaqstate7] = useState(false)

    function openfaq7(){
        setfaqstate7(faqstate7 => !faqstate7)
    }

    let toggleClassCheck7 = faqstate7 ? ' active' : '';

    const [faqstate8, setfaqstate8] = useState(false)

    function openfaq8(){
        setfaqstate8(faqstate8 => !faqstate8)
    }

    let toggleClassCheck8 = faqstate8 ? ' active' : '';

    const [faqstate9, setfaqstate9] = useState(false)

    function openfaq9(){
        setfaqstate9(faqstate9 => !faqstate9)
    }

    let toggleClassCheck9 = faqstate9 ? ' active' : '';




  return (
    <section className='faqs'>
        <h2>Frequently Asked Questions</h2>
        <div className="container faqs_container">
            {/* <article className="faq active" onClick={openfaq}> */}
            <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
                <div className="faq_icon">{faqstate ? <AiOutlineMinus /> : <AiOutlinePlus />}</div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck1}`} onClick={openfaq1}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck2}`} onClick={openfaq2}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck3}`} onClick={openfaq3}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck4}`} onClick={openfaq4}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck5}`} onClick={openfaq5}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck6}`} onClick={openfaq6}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck7}`} onClick={openfaq7}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck8}`} onClick={openfaq8}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
            <article className={`faq${toggleClassCheck9}`} onClick={openfaq9}>
                <div className="faq_icon"><AiOutlinePlus /></div>
                <div className="question_answer">
                    <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
                    </p>
                </div>
            </article>
        </div>
        <Footer />
    </section>
  )
}

export default Faqs

// import React from 'react'
// import './faqs.css'
// import {AiOutlinePlus} from 'react-icons/ai'
// import { useState } from 'react'

// const Faqs = () => {
   
//     const [faqstate, setfaqstate] = useState(false)

//     function openfaq(){
//         setfaqstate(faqstate => !faqstate)
//     }

//     let toggleClassCheck = faqstate ? ' active' : '';




//   return (
//     <section className='faqs'>
//         <h2>Frequently Asked Questions</h2>
//         <div className="container faqs_container">
//             {/* <article className="faq active" onClick={openfaq}> */}
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//             <article className={`faq${toggleClassCheck}`} onClick={openfaq}>
//                 <div className="faq_icon"><AiOutlinePlus /></div>
//                 <div className="question_answer">
//                     <h4>Question? Lorem ipsum dolor sit amet consectetur adipisicing.</h4>
//                     <p>
//                         Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur est magnam ratione veritatis nostrum. Delectus, labore error doloribus quidem atque a consequatur facere amet voluptatibus voluptatem omnis, dolorum voluptates sit?
//                     </p>
//                 </div>
//             </article>
//         </div>
//     </section>
//   )
// }

// export default Faqs